import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex justify-center",
  style: {"margin":"8px 0 8px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, { class: "blue-grey lighten-5 primary--text" }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Select language ", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_card_text, { class: "py-3" }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", {
            class: "d-flex justify-center",
            style: {"border":"1px solid #a9a9a9","padding":"8px","border-radius":"8px"}
          }, [
            _createElementVNode("span", { style: {"font-size":"16px"} }, "Multilingual (auto-detect)")
          ], -1)),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_icon, { style: {"font-size":"56px","text-align":"center"} }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("mdi-arrow-down-thin", -1)
              ]))]),
              _: 1
            })
          ]),
          _createVNode(_component_v_select, {
            modelValue: _ctx.targetLanguage,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.targetLanguage) = $event)),
            items: _ctx.languageOptions,
            "item-title": "label",
            "item-value": "value",
            label: "Target language",
            variant: "outlined",
            density: "comfortable",
            "hide-details": ""
          }, null, 8, ["modelValue", "items"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            onClick: _ctx.close,
            color: "error",
            variant: "text"
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Cancel ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            onClick: _ctx.clickPost,
            loading: _ctx.btnLoading,
            color: "primary"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createTextVNode(" Translate ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "loading"]),
          _createVNode(_component_v_spacer)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}